import { connect } from 'react-redux';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getContainerStyles } from '../../../../utils/Utils';

import { getActiveTieredSale } from '../../store/selectors/cart.selectors';

import ParsedMarkdown from './ParsedMarkdown';
import PromotionCopy from './PromotionCopy';

export class SalesTiers extends Component {
  static renderSaleHeader(promotion) {
    const {
      copy,
      description,
      couponCode,
      tiersHighlightColor,
    } = promotion;

    return (
      <div
        className="sales-tiers__copy"
      >
        <PromotionCopy
          tag="h2"
          className="sales-tiers__copy-header"
          copy={copy}
          couponCode={couponCode}
          tiersHighlightColor={tiersHighlightColor}
        />
        {description && (
          <ParsedMarkdown options={{ forceBlock: true }}>
            {description}
          </ParsedMarkdown>
        )}
      </div>
    );
  }

  static renderTiersContent(tieredCoupon) {
    const {
      salesTiers,
    } = tieredCoupon;
    return salesTiers?.length > 1 && (
      <div className="sales-tiers__tier-wrapper">
        {salesTiers.map(({ id, copy }) => (
          <div
            key={id}
            className="sales-tiers__tier"
          >
            {copy && (
              <ParsedMarkdown options={{ forceBlock: true }}>
                {copy}
              </ParsedMarkdown>
            )}
          </div>
        ))}
      </div>
    );
  }

  render() {
    const {
      tieredCoupon,
      hideCopy,
      promotion,
    } = this.props;
    if (!tieredCoupon && !promotion) {
      return '';
    }
    const promo = promotion || tieredCoupon;
    return (
      <div
        className="sales-tiers"
        data-testid="sales-tiers"
        style={getContainerStyles(promo.tiersBackgroundColor, promo.tiersTextColor)}
      >
        <div className="sales-tiers__container">
          {!hideCopy && SalesTiers.renderSaleHeader(promo)}
          {promo && SalesTiers.renderTiersContent(promo)}
          <div className="sales-tiers__terms">
            <p className="sales-tiers__terms-copy">{promo.footnote}</p>
          </div>
        </div>
      </div>
    );
  }
}

SalesTiers.defaultProps = {
  hideCopy: false,
  promotion: null,
  tieredCoupon: null,
};

const ShapePromotion = PropTypes.shape({
  id: PropTypes.string,
  tiersTextColor: PropTypes.object,
  tiersBackgroundColor: PropTypes.object,
  copy: PropTypes.string,
  description: PropTypes.string,
  tiersHighlightColor: PropTypes.object,
  couponCode: PropTypes.string,
  salesTiers: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    copy: PropTypes.string,
    couponCode: PropTypes.string,
  })),
});

SalesTiers.propTypes = {
  promotion: ShapePromotion,
  hideCopy: PropTypes.bool,
  tieredCoupon: ShapePromotion,
};

const mapStateToProps = (state) => ({
  tieredCoupon: getActiveTieredSale(state),
});

export default connect(mapStateToProps, null)(SalesTiers);
